import { fetchLatest } from '@/services/userService';
import store from '.';
export interface LatestState {
  specialoffer: number | null
  campaign: number | null
  news: number | null
  pickup: number | null
  date: Date | null
}
export const LatestMenu = {
  namespaced: true,
  state(): LatestState {
    return {
      specialoffer: null,
      campaign: null,
      news: null,
      pickup: null,
      date: null,
    }
  },
  getters: {
    specialoffer: (state: LatestState) => {
      return state.specialoffer;
    },
    campaign: (state: LatestState) => {
      return state.campaign;
    },
    news: (state: LatestState) => {
      return state.news;
    },
    pickup: (state: LatestState) => {
      return state.pickup;
    },
    date: (state: LatestState) => {
      return state.date;
    },
  },
  mutations: {
    setSpecialoffer: (state: LatestState, data: LatestType[] | null) => {
      if (!data) {
        state.news = null;
        return;
      }
      let count: number = 0;
      const result = data.find( ({ id }) => id === 'specialoffer' );
      if (result) {
        count = result.value;
      }
      state.specialoffer = count;
    },
    setCampaign: (state: LatestState, data: LatestType[] | null) => {
      if (!data) {
        state.news = null;
        return;
      }
      let count: number = 0;
      const result = data.find( ({ id }) => id === 'campaign' );
      if (result) {
        count = result.value;
      }
      state.campaign = count;
    },
    setNews: (state: LatestState, data: LatestType[] | null) => {
      if (!data) {
        state.news = null;
        return;
      }
      let count: number = 0;
      const result = data.find( ({ id }) => id === 'news' );
      if (result) {
        count = result.value;
      }
      state.news = count;
    },
    setPickup: (state: LatestState, data: LatestType[] | null) => {
      if (!data) {
        state.news = null;
        return;
      }
      let count: number = 0;
      const result = data.find( ({ id }) => id === 'pick-up' );
      if (result) {
        count = result.value;
      }
      state.pickup = count;
    },
    setDate: (state: LatestState, data: string | null) => {
      if (!data) {
        state.news = null;
        return;
      }
      const date = new Date(data)

      if (isNaN(date.getTime())) {
        // 不正な日付
        state.date = null
        return
      }
    
      state.date = date
    },
  },
  actions: {
    update: async (cxt: any, param: TokenParams) => {
      await fetchLatest()
      .then( (response) => {
          cxt.commit('setSpecialoffer', response.type);
          cxt.commit('setCampaign', response.type);
          cxt.commit('setNews', response.type);
          cxt.commit('setPickup', response.type);
      })
    },
  },
};
